import './order.less';
import React from 'react';
import PropTypes from 'prop-types';

import Order from '../../../shared/order-list/main';
import find from 'lodash/find';
import get from 'lodash/get';
import PaginationButton from './paginationButton';

const propTypes = {
	orderOfferList: PropTypes.array,
	toggleSwitchToOrder: PropTypes.func,
	intl: PropTypes.func,
	orderSortedEnd: PropTypes.func,
	saveOrderSort: PropTypes.func,
	shouldShowSaveOrderBtn: PropTypes.bool,
	lists: PropTypes.object
};

const SortableOrder = ({
	orderOfferList,
	toggleSwitchToOrder,
	intl,
	table,
	fetchMore,
	orderSortedEnd,
	saveOrderSort,
	shouldShowSaveOrderBtn,
	lists
}) => (
	<div className="table-container table-container--projector sortable-offers-wrap">
		<div className="table-container--projector__header">
			<div className="sortable-offers-wrap__header">
				<p className="sortable-offers-wrap__header-name font-roboto-medium">{intl('Offer')}</p>
				<a
					href="javascript:;"
					className="order-close"
					onClick={toggleSwitchToOrder}>
					{intl('Return to list of offers')}
				</a>
				{ shouldShowSaveOrderBtn && (
					<p
						className="order-action-btn order-action-btn--order"
						onClick={() => {
							confirm(intl('Change offer sort ?')) && saveOrderSort();
						}}>
						<span>{intl('Save order')}</span>
					</p>
				) }

				<div className="sortable-offers-wrap__header-position-right">
					<p className="sortable-offers-wrap__header-geo font-roboto-medium">{intl('Geo')}</p>
					<p className="sortable-offers-wrap__header-lang font-roboto-medium">{intl('Lang')}</p>
				</div>
			</div>
		</div>
		<div className="table-container--projector__body">
			<div className="table-container--projector__body-content">
				<Order onSortEnd={orderSortedEnd}>
					{ orderOfferList.map((row, index) => (
						<Order.Item key={row.id} id={row.id}>
							<div className="sortable-offers-wrap__item">
								<span className="sortable-offers-wrap__item-drag" />
								<div className="sortable-offers-wrap__item-title">
									<span className="sortable-offers-wrap__item-title__img">
										<img src={row.image || '//placehold.it/40x40'} alt="offer img"/>
									</span>
									<span className="sortable-offers-wrap__item-title__text">
										{row.title}
									</span>
									<span className="status">({row.status})</span>
								</div>
								<div className="sortable-offers-wrap__item-geo-count">
									<div className="geo-text">
										{row.geo && row.geo.length}
									</div>
									{row.geo && row.geo.length > 0 &&
									<div className="segments-popup">
										{row.geo.map(location => (
											<div key={location.id}>
												<div>
													<span className=
														{`geo-country__flag flag-icon flag-icon-${location.country_code.toLowerCase()}`}/>
													<span className="geo-country__name">{location.name}</span>
												</div>
											</div>
										))}
									</div>}
								</div>
								<div className="sortable-offers-wrap__item-lang-count">
									<div className="lang-text">
										{row.languages && row.languages.length}
									</div>
									{row.languages && row.languages.length > 0 &&
									<div className="segments-popup">
										{row.languages.map(lang => (
											<div key={lang}>{find(lists['landing-languages'], {id: lang}).text} </div>
										))}
									</div>}
								</div>
							</div>
						</Order.Item>
					)) }
				</Order>
			</div>
		</div>
		{table.totalRows < get(table.rows, '[0].total_count', 0) && (
			<div className="table-container__navigation">
				<PaginationButton intl={intl} fetchMore={fetchMore} />
			</div>
		)}
	</div>
);

SortableOrder.propTypes = propTypes;
export default SortableOrder;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/components/table/order.js